import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "subscription-box__title-box" }
const _hoisted_2 = { class: "subscription-box__title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "plan-cards__cards" }
const _hoisted_5 = { class: "plan-cards__button-box" }
const _hoisted_6 = {
  key: 1,
  class: "plan-cards__info plan-cards__info--android"
}
const _hoisted_7 = {
  key: 2,
  class: "plan-cards__info plan-cards__info--regular"
}

import { AppStoreBillingView, BillingView, PlanView } from '@/models/billing'

import PlanCard from './PlanCard.vue'
import BillingSubscribeButton from '@/app/components/billing/BillingSubscribeButton.vue'
import { computed, onMounted, Raw, ref } from 'vue'
import { platform } from '@/services/platform'
import { trialByPlan15535Treatment } from '@/services/ab/15535_trial_by_plan'
import { assertNotNull } from '@/helpers/typing'


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanCards',
  props: {
    billing: {},
    isSecondary: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const selectedPlan = ref<Raw<PlanView>>(props.billing.annualPlan)

const updateSelectedPlan = (planId: string): void => {
  selectedPlan.value =
    planId === 'plan_annual'
      ? props.billing.annualPlan
      : props.billing.monthlyPlan
}

const isAndroidApp = ref(false)

onMounted(async () => {
  // On the Android native app, we show text informing users of the
  // free content they can access, so that we do not violate the
  // Subscriptions policy. See issue #10818.
  isAndroidApp.value = await platform.isNativeAndroidApp()
})

const annualPlan = computed(() => {
  if (props.billing.showExternalPayment16218) {
    const billing = props.billing as AppStoreBillingView
    return assertNotNull(billing.stripeAnnualPlan16218)
  }

  return props.billing.annualPlan
})

const monthlyPlan = computed(() => {
  if (props.billing.showExternalPayment16218) {
    const billing = props.billing as AppStoreBillingView
    return assertNotNull(billing.stripeMonthlyPlan16218)
  }

  return props.billing.monthlyPlan
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container plan-cards", { 'plan-cards__secondary': __props.isSecondary }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.billing.subscriptionBoxTitle), 1)
    ]),
    (_unref(trialByPlan15535Treatment)())
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "plan-cards__info plan-cards__info--top",
          innerHTML: __props.billing.subscriptionBoxInfo
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(PlanCard, {
        plan: annualPlan.value,
        billing: __props.billing,
        selected: selectedPlan.value.id === 'plan_annual',
        class: "plan-cards__card--annual",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (updateSelectedPlan('plan_annual')))
      }, null, 8, ["plan", "billing", "selected"]),
      _createVNode(PlanCard, {
        plan: monthlyPlan.value,
        billing: __props.billing,
        selected: selectedPlan.value.id === 'plan_monthly',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (updateSelectedPlan('plan_monthly')))
      }, null, 8, ["plan", "billing", "selected"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(BillingSubscribeButton, {
        billing: __props.billing,
        plan: selectedPlan.value,
        location: props.isSecondary ? 'top' : 'bottom'
      }, null, 8, ["billing", "plan", "location"])
    ]),
    (isAndroidApp.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
          _cache[4] || (_cache[4] = _createTextVNode(" The free trial will start unless you had a subscription in the past in which case the subscription will start immediately. Please check the details on the popup that will appear after clicking the button. You can get a taste of Shortform right now with our free summaries of ", -1)),
          _createVNode(_component_router_link, { to: {
          name: 'book.preview',
          params: { url_slug: 'deep-work' },
        } }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Deep Work", -1)
            ]))]),
            _: 1
          }),
          _cache[5] || (_cache[5] = _createTextVNode(" and ", -1)),
          _createVNode(_component_router_link, { to: {
          name: 'book.preview',
          params: {
            url_slug: 'how-to-win-friends-and-influence-people',
          },
        } }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("How to Win Friends and Influence People", -1)
            ]))]),
            _: 1
          }),
          _cache[6] || (_cache[6] = _createTextVNode(". ", -1))
        ]))
      : _createCommentVNode("", true),
    (!_unref(trialByPlan15535Treatment)())
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.billing.subscriptionBoxInfo), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})